export type NarrowTableMode = 'fit' | 'scroll' | null;
export const narrowTableMode = (value: unknown): NarrowTableMode => value === 'fit' || value === 'scroll' ? value : null;

export function responsiveTableWrapper(mode: Exclude<NarrowTableMode, null>, caption = '') {
    return { class: 'lesson-table-responsive', 'data-narrow-screen': mode,
        ...(mode === 'scroll' ? { tabindex: 0, role: 'region', 'aria-label': caption ? `Scrollable table: ${caption}` : 'Scrollable table' } : {}) };
}

/** Also supports authored table HTML containing the setting but no wrapper yet. */
export function prepareResponsiveTables(doc: Document): void {
    doc.querySelectorAll<HTMLTableElement>('table[data-narrow-screen]').forEach(table => {
        const mode = narrowTableMode(table.getAttribute('data-narrow-screen'));
        if (!mode) return;
        let wrapper = table.parentElement;
        if (!wrapper?.classList.contains('lesson-table-responsive')) {
            wrapper = doc.createElement('div');
            table.before(wrapper); wrapper.appendChild(table);
        }
        const attributes = responsiveTableWrapper(mode, table.getAttribute('data-caption') || '');
        wrapper.setAttribute('data-narrow-screen', mode);
        wrapper.classList.add('lesson-table-responsive');
        for (const key of ['tabindex', 'role', 'aria-label']) {
            const value = (attributes as Record<string, unknown>)[key];
            if (value == null) wrapper.removeAttribute(key); else wrapper.setAttribute(key, String(value));
        }
    });
}

export const TABLE_RESPONSIVE_STYLES = `
.lesson-table-responsive { display:block; width:100%; max-width:100%; min-width:0; box-sizing:border-box; }
/* Neutral colours keep navigation visible even when a lesson theme uses very
   similar surface colours for its native scrollbar thumb and track. */
.lesson-table-responsive[data-narrow-screen="scroll"] { overflow-x:auto; scrollbar-width:auto; scrollbar-color:#64748b #e2e8f0; }
.lesson-table-responsive[data-narrow-screen="scroll"]::-webkit-scrollbar { height:14px; }
.lesson-table-responsive[data-narrow-screen="scroll"]::-webkit-scrollbar-track { background:#e2e8f0; border-radius:7px; }
.lesson-table-responsive[data-narrow-screen="scroll"]::-webkit-scrollbar-thumb { background:#64748b; border:2px solid #e2e8f0; border-radius:7px; }
.lesson-table-responsive[data-narrow-screen="scroll"]::-webkit-scrollbar-thumb:hover { background:#475569; }
.lesson-table-responsive:focus-visible { outline:2px solid var(--primary-color,currentColor); outline-offset:2px; }
@media(max-width:640px) {
  .lesson-table-responsive[data-narrow-screen="scroll"] > table.table-rendered { min-width:640px !important; }
  .lesson-table-responsive[data-narrow-screen="fit"] > table.table-rendered { width:100% !important; min-width:0 !important; max-width:100% !important; table-layout:fixed !important; }
  .lesson-table-responsive[data-narrow-screen="fit"] > table.table-rendered :is(col,th,td) { width:auto !important; min-width:0 !important; white-space:normal !important; overflow-wrap:anywhere; }
  .lesson-table-responsive[data-narrow-screen="fit"] > table.table-rendered :is(th,td) :is(p,span,a) { white-space:normal !important; overflow-wrap:anywhere; }
  .lesson-table-responsive[data-narrow-screen="fit"] > table.table-rendered :is(th,td) :is(div,figure) { max-width:100% !important; min-width:0 !important; box-sizing:border-box; }
  .lesson-table-responsive[data-narrow-screen="fit"] > table.table-rendered :is(img,video,iframe,input,select,textarea) { max-width:100% !important; box-sizing:border-box; min-width:0 !important; }
  .lesson-table-responsive[data-narrow-screen="fit"] > table.table-rendered img { height:auto !important; }
}
`;
